import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import jwtDecode from 'jwt-decode'
import {useEffect, useMemo} from 'react'
import {useFragment} from 'react-relay'
import AtlassianProviderLogo from '../../../../AtlassianProviderLogo'

import AtlassianConfigMenu from '../../../../components/AtlassianConfigMenu'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps, {} from '../../../../hooks/useMutationProps'

import {ExternalLinks, Providers} from '../../../../types/constEnums'
import AtlassianClientManager, {ERROR_POPUP_CLOSED} from '../../../../utils/AtlassianClientManager'
import ProviderRow from './ProviderRow'







const useFreshToken = (accessToken, retry) => {
  useEffect(() => {
    if (!accessToken) return
    const decodedToken = jwtDecode(accessToken) 
    const delay = (decodedToken && decodedToken.exp * 1000 - Date.now()) || -1
    if (delay <= 0) return
    const cancel = window.setTimeout(() => {
      retry()
    }, delay)
    return () => {
      window.clearTimeout(cancel)
    }
  }, [accessToken, retry])
}

const AtlassianProviderRow = (props) => {
  const {retry, viewer: viewerRef, teamId} = props
  const viewer = useFragment(
    graphql`
      fragment AtlassianProviderRow_viewer on User {
        teamMember(teamId: $teamId) {
          integrations {
            atlassian {
              ...AtlassianProviderRowAtlassianIntegration @relay(mask: false)
            }
          }
        }
      }
    `,
    viewerRef
  )
  const atmosphere = useAtmosphere()
  const {submitting, submitMutation, onError, error, onCompleted} = useMutationProps()
  const mutationProps = {submitting, submitMutation, onError, onCompleted} 
  const {teamMember} = viewer
  const {integrations} = teamMember
  const {atlassian} = integrations
  const accessToken = _nullishCoalesce(_optionalChain([atlassian, 'optionalAccess', _ => _.accessToken]), () => ( undefined))
  useFreshToken(accessToken, retry)

  const openOAuth = () => {
    AtlassianClientManager.openOAuth(atmosphere, teamId, mutationProps)
  }

  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_RIGHT)

  const errorMessage = useMemo(() => {
    if (!error) return undefined
    const {message} = error
    if (message === ERROR_POPUP_CLOSED) {
      return (
        _jsxs(_Fragment, { children: ["Having trouble authorizing Parabol? Try our"
               , ' '
          , _jsx('a', {
            href: ExternalLinks.INTEGRATIONS_SUPPORT_JIRA_AUTHORIZATION,
            target: "_blank",
            rel: "noreferrer",
 children: "troubleshooting guide"

          })
        ]})
      )
    }
    return message
  }, [error])

  if (!AtlassianClientManager.isAvailable) return null

  return (
    _jsxs(_Fragment, { children: [
      _jsx(ProviderRow, {
        connected: !!accessToken,
        onConnectClick: openOAuth,
        submitting: submitting,
        togglePortal: togglePortal,
        menuRef: originRef,
        providerName: Providers.ATLASSIAN_NAME,
        providerDescription: Providers.ATLASSIAN_DESC,
        providerLogo: _jsx(AtlassianProviderLogo, {} ),
        error: errorMessage,}
      )
      , menuPortal(
        _jsx(AtlassianConfigMenu, { mutationProps: mutationProps, menuProps: menuProps, teamId: teamId,} )
      )
    ]})
  )
}

graphql`
  fragment AtlassianProviderRowAtlassianIntegration on AtlassianIntegration {
    accessToken
  }
`

export default AtlassianProviderRow
